<template>
  <div>
    <the-nav-bar>
      <component :is="layout"/>
    </the-nav-bar>
    <div v-show="!loading" class="section">
      <slot />
    </div>
    <div v-show="loading">
      <loader/>
    </div>
  </div>
</template>

<script>
import TheNavBar from './TheNavBar.vue';
import MotorNavBar from '../Motor/NavBar.vue';
import Loader from './Loader.vue';

export default {
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  components: {
    MotorNavBar,
    TheNavBar,
    Loader
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'motor'}-nav-bar`;
    }
  },
};
</script>
